import React from 'react';
import './styles.scss';
import { useTranslation } from 'react-i18next';
import { useNumberFormatter } from '../../../../../hooks/useNumberFormatter';
import MultipleProgressBar from '../MultipleProgressBar/MultipleProgressBar';
import { financialAdvanceStatusColors } from '../../view/Common/NomenclatureItems';
import { capitalizeFirstLetter } from '../../../../../services/stringUtil';

function FinancialAdvanceProgress({ disbursmentAmount, disbursment, committedAmount, committed, pendignAmount, pending }) {
    const { t } = useTranslation();
    const { formatNumber } = useNumberFormatter();

    const getProgressBarData = () => {
        return {
            disbursment,
            committed,
            pending
        }
    }

    return (
        <div className='c-progress-bar'>
            <MultipleProgressBar data={getProgressBarData()} options={financialAdvanceStatusColors} showPercent={false} />

            <div className='c-linear_amount_porcent-data'>
                <div className='content-data'>
                    <p className='initial-status-text'>🔵 {capitalizeFirstLetter(t('done'))}</p>
                    <div className="percent">
                        {disbursment} %
                    </div>
                    <div className='amount'>
                        {formatNumber(disbursmentAmount)} {t('dolar_sign')}
                    </div>
                </div>

                <div className='content-data'>
                    <p className='commited-status-text'>🟠 {t('committed_financial')}</p>
                    <div className="percent">
                        {committed} %
                    </div>
                    <div className='amount'>
                        {formatNumber(committedAmount)} {t('dolar_sign')}
                    </div>
                </div>

                <div className='content-data'>
                    <p className='pending-status-text'>🔘 {t('pending')}</p>
                    <div className="percent">
                        {pending} %
                    </div>
                    <div className='amount'>
                        {formatNumber(pendignAmount)} {t('dolar_sign')}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FinancialAdvanceProgress;